import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat',
  standalone: true
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: number): string {
    if (!value || value < 0) return '0 Min';

    const minutes = Math.floor(value / 60);
    const seconds = Math.round(value % 60);
    if (seconds === 0) {
      return `${minutes} Min`;
    }

    return `${minutes} Min ${seconds} Sec`;
  }
}
